import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

const SESSION_KEY = "av_session_id";

function getOrCreateSessionId(): string {
  try {
    let id = localStorage.getItem(SESSION_KEY);
    if (!id) {
      id = crypto.randomUUID();
      localStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return "anon-" + Math.random().toString(36).slice(2);
  }
}

/**
 * Logs a page view to Supabase on every route change.
 * Fires-and-forgets — never blocks rendering.
 */
export function useVisitorTracking() {
  const location = useLocation();

  useEffect(() => {
    const sessionId = getOrCreateSessionId();
    const path = location.pathname + location.search;

    // Defer to idle so it never blocks paint
    const fire = () => {
      supabase
        .from("page_views")
        .insert({
          session_id: sessionId,
          path,
          referrer: document.referrer || null,
          user_agent: navigator.userAgent,
        })
        .then(() => {
          /* swallow */
        });
    };

    if ("requestIdleCallback" in window) {
      (window as any).requestIdleCallback(fire, { timeout: 2000 });
    } else {
      setTimeout(fire, 500);
    }
  }, [location.pathname, location.search]);
}
